import React, {Component} from 'react';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import devToolsEnhancer from 'remote-redux-devtools';

import BillingLayout from './billing_layout/billing_layout';
import billingReducer from './billing_reducer';
import usersReducer from '../global/user/user_reducer';
import organizationReducer from '../global/organization/organization_reducer';

import AppFrameLayout from '../global/app_frame/app_frame_layout';
import appFrameReducer from '../global/app_frame/app_frame_reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;


const rootReducer = combineReducers({
    billing: billingReducer,
    user: usersReducer,
    organziation: organizationReducer,
    app_frame: appFrameReducer
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

class BillingApp extends Component {

    render () {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <AppFrameLayout>
                        <BillingLayout />
                    </AppFrameLayout>
                </BrowserRouter>
            </Provider>
        )
    }
}

export default BillingApp;